<div class="recognition-page-wrapper">

  <div class="Supplier-page-wordings">
    <div class="Supplier-page-heading-inner">
      <span class="Supplier-page-heading">Supplier Recognition</span>
      <img class="gigaton-icon-inner" alt="Supplier" src="../../../../../assets/images/project-gigatonlogo.png">
      <img class="walmart-icon-inner" alt="Supplier" src="../../../../../assets/images/walmart-logo-without-bg.png">
    </div>

    <div class="recognition-para1">
      <p>
        We are excited to feature suppliers that have joined, set goals, and demonstrated results through <a href="https://www.walmartsustainabilityhub.com/project-gigaton">Project Gigaton</a>, Walmart's initiative to reduce, avoid, or sequester 1 billion metric tons of CO2e emissions in the global value chain and, together with the Walmart Foundation, to protect, restore or more sustainably manage 50 million acres of land and 1 million square miles of ocean by 2030.
      </p>
      <p>
        If your company would like to be recognized by this page, <a href={{loginURL}} target="_blank" rel="noopener">join Project
          Gigaton</a>, set goals, report progress, and agree to share your goals and logo publicly! For more detailed requirements on recognition requirements, click on the Giga Guru and Sparking Change logos below.
          See our  <a href="https://www.walmartsustainabilityhub.com/reporting/faqs" target="_blank" rel="noopener">FAQ's
          </a> for information on status, which was assessed in early 2025.
      </p>
      <p>
        Recognition status resets each year after our Sustainability Survey and must be re-earned by meeting the reporting requirements before the close of the survey. Recognition status will be re-published in the first quarter of each calendar year based on the previous survey participation.</p>
    </div>
  </div>


    <div class="Card-space" *ngIf="!inProgress">
      <div class="rTable">

        <div class="rTableRow">
          <app-score-card class="child1" [cardValue]="totalSuppliers" [cardName]='TotalSuppliers'
            [cardIcon]='TotalSuppliersIcon'></app-score-card>

          <app-score-card class="child1" [cardValue]="gigaGuru" [cardName]='Gigaguru' [cardTooltip]='GigaguruTooltip'
            [cardIcon]='gigaguruIcon'></app-score-card>

          <app-score-card class="child1" [cardValue]="sparkingChange" [cardName]='SparkingChange'
            [cardTooltip]='SparkingChangeTooltip' [cardIcon]='sparkingChangeIcon'></app-score-card>

        </div>
      </div>
    </div>
    <br>

    <mat-card *ngIf="!inProgress">
      <!-- //NOSONAR --> <table mat-table class="table-style">
        <thead class="">
          <div class="table-head">
            <div scope="col" class="table-heading">Giga-Gurus and Sparking Change Suppliers</div>
            <div class="search-box">
              <img class="search-icon" src="../../../../../assets/images/search-icon.png" alt="search">
              <input matInput class="search-label" [(ngModel)]="searchByName" (ngModelChange)="clearSearchResult($event)"
                (keyup.enter)="$event.keyCode == 13 ? searchSupplier() : null" placeholder="Search Suppliers">
              <div class="campaign-search-btn" (click)="searchSupplier()">
                <span class="btn-label">SEARCH</span>
              </div>
            </div>
          </div>
    <hr class="horizontal-line">
        </thead>


        <!-- //NOSONAR --> <div class="table-inner" >
          <ngx-spinner [fullScreen]="false" bdColor="transparent" size="large" color="#fdbb30"
            type="line-spin-clockwise-fade"></ngx-spinner>
          <cdk-virtual-scroll-viewport itemSize="20" class="rec-parent">

            <td  *ngIf="generalDetails && generalDetails.totalCount===0 && generalDetails.isLoaded">
              <div class="no-data-container">
                <p class="no-data-message">
                  <em class="material-icons">error_outline</em>
                  {{"NORECORDS" | translate}}
                </p>
              </div>
            </td>
            <div class="rec-child" *cdkVirtualFor="let sp of generalDetails">
              <td class="supplier-tab"  (click)="openCompanyDetailsDialog(sp)">
                <div class="supplier-logo">
                  <img [src]="imageSource(sp.logo)" [ngClass]="{
            'image-src-noIcon': imageSrc === 'default',
            'image-src': imageSrc !== 'default',
            'image-src-ust': sp.companyName === 'UST Global INC'
          }" alt="" />


                </div>

                <div class="companyName">{{sp.companyName}} </div>
                <div *ngIf="sp.gigaGuru === 'Yes'; else elseBlock" class="recognitionIcon-cover-gigaguru">
                  <img class="regonitionIcon-inner-gigaguru" alt="GIGA-GURU" src="assets/images/W-GIGA-GURU_25.png">
                </div>

                <ng-template #elseBlock>
                  <div class="recognitionIcon-cover-sparking">
                    <img class="regonitionIcon-inner-sparkingchange" alt="SPARKING-CHANGE"
                      src="assets/images/W-SPARKING-CHANGE_25.png">
                  </div>
                </ng-template>
              </td>
            </div>
          </cdk-virtual-scroll-viewport>

        </div>
      </table>
    </mat-card>
  <div *ngIf="inProgress" class="inprogress-sec">
    <div class="data-load">
      {{'COMING_SOON' | translate}}
    </div>
    <div class="img-section">
      <img src="assets\images\gigaton-working.png" class="img-working" alt="">
    </div>
  </div>
</div>

<ng-template #companyDetailPopupTemplate>
  <company-dialog [companyName]="companyName" [companyStatus]="companyStatus" [companyLogo]="companyLogo">
 </company-dialog>
</ng-template>
